import { Model } from '@/models/Model';
export class SubjectStatusSummary extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'SubjectStatusSummary';
        this.$endpoint = '/subjects/status-summary';
        this.$fillable = [];
    }
}
